import Vue from 'vue'
import VueCookies from 'vue-cookies'

import axios from 'axios'

import App from '@/App'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import { VTabs } from 'vuetify/lib'

import DefaultLayout from '@/layouts/Default'
import MainLayout from '@/layouts/Main'

import { RouteName, Url } from '@/utility/constants'
import { dateFormatterUTC, dateLongFormatterUTC, formatDecimal, formatFileSize } from './utility/utility'

Vue.component('default-layout', DefaultLayout)
Vue.component('main-layout', MainLayout)

let isDevelopment = process.env.NODE_ENV === 'development'

Vue.config.productionTip = isDevelopment
Vue.config.devtools = isDevelopment

axios.interceptors.response.use((res) => {
	return Promise.resolve(res)
}, (error) => {
		if (error && error.response.status === 401) {
			window.location.href = Url.HOME
		}

		return Promise.reject(error)
})

Vue.prototype.$http = axios

Vue.use(VueCookies)

Vue.filter('formatDate', dateFormatterUTC)
Vue.filter('formatLongDate', dateLongFormatterUTC)
Vue.filter('formatDecimal', formatDecimal)
Vue.filter('formatFileSize', formatFileSize)

router.beforeEach(async (to, from, next) => {
    if (to.meta && to.meta.auth) {
        if (!await store.dispatch('fetchUser')) {
            // If redirecting to a server-rendered page, use window.location.href here
            next({
                name: RouteName.SIGN_IN,
                params: { loginRedirect: to.path }
            })
            return
        }
    }
    next();
})

// Vuetify has some odd bugs with highlighted tab rendering.
// This is a hack to make any VTabs components forcibly refresh visually whenever all files on the page are loaded.
// (It appears the CSS on the page is loading after the highlight is rendered, which is causing the font to change and the tabs to shift)
VTabs.options.mounted.push(function () {
    // For some reason the load event happens on cached resources before the DOM renders, so it seems like the same shifting is happening, but without any lifecycle hook to react to in the browser
    // I am not sure whether this will actually be a problem in production builds, since everything is packaged differently
    // It's actually even more confusing because HMR causes the load event to be triggered more frequently in dev once you edit anything
    setTimeout(() => this.onResize(), 500)

    // Once resources are loaded, update the hightlight
    let resizeVTabs = () => {
        setTimeout(() => this.onResize(), 0)
        window.removeEventListener('load', resizeVTabs)
    }
    window.addEventListener('load', resizeVTabs)
})

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
